/**
 * Appends the additions that are not already present, returning the original array when none are.
 *
 * @param current - The existing array, left as-is including any duplicates it already holds
 * @param additions - The values to add, themselves de-duplicated
 * @returns The merged array, or `current` itself when nothing was added
 */
export function mergeUnique<T>(current: T[], additions: T[]): T[] {
    const seen = new Set(current);
    const missing = additions.filter(value => {
        if (seen.has(value)) {
            return false;
        }
        seen.add(value);
        return true;
    });

    return missing.length === 0 ? current : [...current, ...missing];
}
